import * as React from 'react';
/**
 * @hidden
 */
export var DialogTitleBar = function (_a) {
    var children = _a.children, onCloseButtonClick = _a.onCloseButtonClick, id = _a.id, closeIcon = _a.closeIcon;
    return (React.createElement("div", { className: "k-window-titlebar k-dialog-titlebar k-header", id: id },
        React.createElement("div", { className: "k-window-title k-dialog-title" }, children),
        React.createElement("div", { className: "k-window-actions k-dialog-actions" }, closeIcon &&
            React.createElement("a", { href: "#", role: "button", "aria-label": "Close", onClick: onCloseButtonClick, className: "k-button k-flat k-button-icon k-window-action k-dialog-action k-dialog-close" },
                React.createElement("span", { className: "k-icon k-i-x" })))));
};
//# sourceMappingURL=DialogTitleBar.js.map